<div>
    @if (showIcon) {
        <i [ngClass]="iconClass"></i>
    }
    @if (detail.description) {
        <span class="contact-description">{{ detail.description }}</span>
    }
    <a [attr.href]="url">{{ detail.value }}</a>
    @if (detail.isPrivate) {
        <span class="ps-1">
            <small class="fal fa-lock"
                   adaptTooltip="This information is only visible to this person and those with permission to view private profile data"></small>
        </span>
    }
</div>
